import Box from "@mui/material/Box";
import type { ReactNode } from "react";
import { useAppCustomStyles } from "../../assets/theme/custom/hooks";

type Props = {
  children: ReactNode;
};

/** Standard outer wrapper for dashboard layout page content (replaces ad-hoc Grid shells). */
export default function PageContentShell({ children }: Props) {
  const custom = useAppCustomStyles();
  return (
    <Box sx={custom.page.pageContentShell}>
      {children}
    </Box>
  );
}
